export const filterNames = {
  pov: "creator type",
  demographic: "people in videos",
  note: "my notes",
  influencer: "creator name",
  product: "product name",
  category: "product category",
  age_range: "age",
  brand_safety: "brand safety",
  foul_language: "foul language",
  visual_content: "visual content",
  sponsored_by: "sponsored by",
  sponsorship: "",
  platform: "platform",
  competitor_brands: "competitor brands",
  brand: "brand",
  subscribers: "number of subscribers",
  videos: "number of videos",
};

export const filterIcons = {
  category: "product",
  brand_safety: "brand-safety",
  audio_labels: "volume",
  competitor_brands: "brand",
};

export const influencerTypes = ["brand", "expert", "fan", "press"];

export const videoCounts = [10, 25, 50, 100, 250, 500, 1000];

export const ethnicities = ["asian", "black", "white", "hispanic", "indian"];

export const filterValues = {
  asian: "Asian",
  black: "Black/African Descent",
  white: "White (non-Hispanic)",
  hispanic: "Hispanic/Latino/Spanish Origin",
  indian: "South Asian (Indian Sub-continent)",
  fl_misoginistic_words: "misogynistic words",
  fl_swear_words: "swear words",
  fl_racial_words: "racial words",
  fl_sexual_words: "sexual words",
  within_last_24hrs: "Within last 24hrs",
  within_1_week: "Within 1 Week",
  within_1_month: "Within 1 Month",
  all_time: "All time",
  "1k_plus_views": "1K + Views",
  "1k_plus_comments": "1K + Comments",
};

export const verticals = [
  "CPG",
  "airlines",
  "electronics",
  "automotive",
  "beauty",
  "other (general)",
];

export const subscriberCounts = [
  10 * 1000,
  25 * 1000,
  50 * 1000,
  100 * 1000,
  250 * 1000,
  500 * 1000,
  1000 * 1000,
];

export const viewCounts = [
  300,
  1000,
  3 * 1000,
  10 * 1000,
  30 * 1000,
  100 * 1000,
  300 * 1000,
];

export const ageRanges = [
  "0-2",
  "3-6",
  "7-12",
  "13-18",
  "18-24",
  "25-30",
  "30-40",
  "40-50",
  "50-60",
  "60+",
];

export const isoCountries = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua And Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, Democratic Republic",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island & Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle Of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States Of",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts And Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre And Miquelon",
  VC: "Saint Vincent And Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome And Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia And Sandwich Isl.",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard And Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad And Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks And Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis And Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const countryOptions = Object.keys(isoCountries)
  .map((code) => ({
    value: code,
    label: isoCountries[code],
  }))
  .sort((a, b) => (a.label > b.label ? 1 : -1));

export const isoLanguages = {
  ab: "Abkhaz",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan; Valencian",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa; Chewa; Nyanja",
  zh: "Chinese",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi; Dhivehi; Maldivian;",
  nl: "Dutch",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fula; Fulah; Pulaar; Pular",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek, Modern",
  gn: "Guaraní",
  gu: "Gujarati",
  ht: "Haitian; Haitian Creole",
  ha: "Hausa",
  he: "Hebrew (modern)",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ga: "Irish",
  ig: "Igbo",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  kl: "Kalaallisut, Greenlandic",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  km: "Khmer",
  ki: "Kikuyu, Gikuyu",
  rw: "Kinyarwanda",
  ky: "Kirghiz, Kyrgyz",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  ku: "Kurdish",
  kj: "Kwanyama, Kuanyama",
  la: "Latin",
  lb: "Luxembourgish, Letzeburgesch",
  lg: "Luganda",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  gv: "Manx",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Māori",
  mr: "Marathi (Marāṭhī)",
  mh: "Marshallese",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  ii: "Nuosu",
  nr: "South Ndebele",
  oc: "Occitan",
  oj: "Ojibwe, Ojibwa",
  cu: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian, Ossetic",
  pa: "Panjabi, Punjabi",
  pi: "Pāli",
  fa: "Persian",
  pl: "Polish",
  ps: "Pashto, Pushto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Kirundi",
  ro: "Romanian, Moldavian, Moldovan",
  ru: "Russian",
  sa: "Sanskrit (Saṁskṛta)",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sm: "Samoan",
  sg: "Sango",
  sr: "Serbian",
  gd: "Scottish Gaelic; Gaelic",
  sn: "Shona",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovene",
  so: "Somali",
  st: "Southern Sotho",
  es: "Spanish; Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  bo: "Tibetan Standard, Tibetan, Central",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  cy: "Welsh",
  wo: "Wolof",
  fy: "Western Frisian",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
};

export const YOUTUBE_API_KEY = "AIzaSyAEaGCuwiE0R0N-3d7u31LnzD8ZJ-FXJek";
export const YOUTUBE_CLIENT_ID =
  "125419013791-lmmml6m54oml9jo1d7vv9lhp4dcgdfof.apps.googleusercontent.com";

export const influencerArchetypes = [
  "Disrupter",
  "Lifestylist",
  "Celebrity",
  "Expert",
  "Editor",
  "Thought Leader",
  "Founder",
  "Personal Brand",
  "Industry Expert",
];

export const licensingDurations = {
  "6 months": 6,
  "1 year": 12,
  "2 years": 24,
};

export const platformTypes = ["Youtube", "Dropbox"];

export const vyrillDataFilterNames = [
  "creator type",
  "people in videos",
  "product name",
  "product category",
  "brand safety",
  "brand",
  "scene",
  "sponsored",
  "topic",
  "language",
  "competitor brands",
];

export const removeTabIcon = ["vyrill-data", "engagement-index"];

export const videoURLTypes = ["YouTube", "DropBox"];

export const extensionLists = [
  "webm",
  "mkv",
  "flv",
  "vob",
  "ogv",
  "ogg",
  "drc",
  "gif",
  "gifv",
  "mng",
  "avi",
  "mts",
  "m2ts",
  "ts",
  "mov",
  "qt",
  "wmv",
  "yuv",
  "rm",
  "rmvb",
  "viv",
  "asf",
  "amv",
  "mp4",
  "m4p",
  "m4v",
  "mp2",
  "mpe",
  "mpv",
  "mpg",
  "mpeg",
  "m2v",
  "svi",
  "3gp",
  "3g2",
  "mxf",
  "roq",
  "nsv",
  "f4v",
  "f4p",
  "f4a",
  "f4b",
];

export const defaultAgeBar = [
  { _id: "18-24", count: 0 },
  { _id: "3-6", count: 0 },
  { _id: "40-50", count: 0 },
  { _id: "0-2", count: 0 },
  { _id: "60+", count: 0 },
  { _id: "13-18", count: 0 },
  { _id: "30-40", count: 0 },
  { _id: "50-60", count: 0 },
  { _id: "7-12", count: 0 },
  { _id: "25-30", count: 0 },
];

export const genderPieLegends = [{ _id: "male" }, { _id: "female" }];

export const ethnicityPieLegends = [
  { _id: "asian" },
  { _id: "black" },
  { _id: "hispanic" },
  { _id: "white" },
  { _id: "indian" },
];

export const licensingTableDurations = {
  "0 mo": 0,
  "3 mo": 3,
  "6 mo": 6,
  "1 yr": 12,
  "2 yrs": 24,
};

export const shortMonth = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec",
};

// Sentiment Report
export const videoFilterBy = [
  {
    value: "youtube_published_at",
    sortBy: "Most Recently Published",
    icon: "fa-regular fa-calendar",
  },
  {
    value: "youtube_view_count",
    sortBy: "Number of Views",
    icon: "fa-regular fa-eye",
  },
  {
    value: "likes",
    sortBy: "Number of Likes",
    icon: "fa-regular fa-thumbs-up",
  },
  {
    value: "youtube_dislike_count",
    sortBy: "Number of Dislikes",
    icon: "fa-regular fa-thumbs-down",
  },
  {
    value: "comment_count",
    sortBy: "Number of Comments",
    icon: "fa-regular fa-message",
  },
];

export const productFilterBy = [
  {
    value: "creators",
    sortBy: "Number of Creators",
    icon: "fa-solid fa-user-group",
  },
  { value: "videos", sortBy: "Number of Videos", icon: "fa-solid fa-video" },
  {
    value: "engagement",
    sortBy: "Total Engagement",
    icon: "fa-solid fa-circle-nodes",
  },
];
// Sentiment Report End

//Home Page date Filters
export const filterButtons = ["1w", "1m", "3m", "6m", "ytd", "1y"];

//Engagement Graph buttons
export const getActiveState = {
  "1w": 0,
  "1m": 1,
  "3m": 2,
  "6m": 3,
  ytd: 4,
  "1y": 5,
  all: 6,
};

export const getButtontype = {
  "1w": "week",
  "1m": "month",
  "3m": "month",
  "6m": "month",
  ytd: "ytd",
  "1y": "year",
};

export const buttonNames = {
  "1w": "1w",
  "1m": "1m",
  "3m": "3m",
  "6m": "6m",
  ytd: "YTD",
  "1y": "1y",
};

export const getButtonDuartionCount = {
  "1w": 1,
  "1m": 1,
  "3m": 3,
  "6m": 6,
  "1y": 1,
};
//Engagement Graph buttons end

//Demographics Pie colors
export const demographicSliceColor = {
  male: "#23BBB8",
  female: "#FF317B",
  hispanic: "#FF5C00",
  south_asian: "#F2B71E",
  asian: "#783AD0",
  black: "#23BBB8",
  white: "#E62580",
  unidentified: "black",
};

//Demographics Pie String Transformations
export const demographicLabelTransform = {
  male: "Male",
  female: "Female",
  asian: "Asian",
  black: "Black",
  hispanic: "Hispanic",
  white: "White",
  south_asian: "South Asian",
  indian: "South Asian",
  unidentified: "Unidentified",
};

export const platformIcons = {
  Youtube: (
    <img
      src={require(`@src/assets/images/vyrill/icons/youtube_icon.png`).default}
      width={18}
    />
  ),
  Tiktok: (
    <img
      src={require(`@src/assets/images/vyrill/icons/tiktok_icon.png`).default}
      width={18}
    />
  ),
  Dropbox: (
    <img
      src={require(`@src/assets/images/vyrill/icons/dropbox_icon.png`).default}
      width={18}
    />
  ),
  GoogleDrive: (
    <img
      src={
        require(`@src/assets/images/vyrill/icons/google_drive_icon.png`).default
      }
      width={18}
    />
  ),
  Instagram: (
    <img
      src={
        require(`@src/assets/images/vyrill/icons/instagram_icon.png`).default
      }
      width={18}
    />
  ),
  // Vyrill_AWS_S3: (
  //   <img
  //     src={require(`@src/assets/images/vyrill/icons/campaign_icon.png`).default}
  //     width={18}
  //   />
  // ),
};

export const DropBoxAppKey = "i470vkj14vr8ywl";

export const productCategories = [
  {
    name: "My Products",
    tab: "My Products",
    image: require(`@images/index-categories/my-products.jpg`).default,
  },
  {
    name: "Competitors",
    tab: "Competition",
    image: require(`@images/index-categories/competitors.jpg`).default,
  },
  {
    name: "Favorites",
    tab: "Favorites",
    image: require(`@images/index-categories/favorites.png`).default,
  },
  // @TODO-trash-feature
  {
    name: "Trash",
    tab: "Trash",
    image: require(`@images/index-categories/trash.png`).default,
  },
];

export const flaggReasonList = [
  "Spam or misleading",
  "Violent or abusive content",
  "Harmful or dangerous acts",
  "Child abuse",
  "Sexual content",
  "Other",
];

export const flaggedCheckedList = [
  "Spam or misleading",
  "Violent or abusive content",
  "Harmful or dangerous acts",
  "Child abuse",
  "Sexual content",
  // "Other",
];

export const videoCategories = [
  {
    name: "My Videos",
    tab: "My Videos",
    image: require(`@images/index-categories/MyVideos.jpg`).default,
  },
  {
    name: "Competitors",
    tab: "Competition",
    image: require(`@images/index-categories/competitors.jpg`).default,
  },
  {
    name: "Campaigns",
    tab: "Campaigns",
    image: require(`@images/index-categories/campaign.png`).default,
  },
  {
    name: "Favorites",
    tab: "favorites",
    image: require(`@images/index-categories/favorites.png`).default,
  },
  {
    name: "Flagged",
    tab: "flagged",
    image: require(`@images/index-categories/flagged.png`).default,
  },
  {
    name: "Trash",
    tab: "Trash",
    image: require(`@images/index-categories/trash.png`).default,
  },
];

export const creatorCategories = [
  {
    name: "My Creators",
    tab: "My Creators",
    image: require(`@images/index-categories/creators.jpg`).default,
  },
  {
    name: "Competitors",
    tab: "Competition",
    image: require(`@images/index-categories/competitors.jpg`).default,
  },
];

export const AppManagerCategories = [
  {
    name: "Brand",
    tab: "brand",
    image: require(`@images/index-categories/brand.jpg`).default,
  },
  {
    name: "Shopper",
    tab: "fan",
    image: require(`@images/index-categories/shopper.jpg`).default,
  },
  // {
  //   name: "All",
  //   tab: "all",
  //   image: require(`@images/index-categories/all.jpg`).default,
  // },
];

export const productFieldPlaceHolder = {
  Product: "Enter your product name here",
  Hashtag: "Enter your hashtag here",
  null: "Enter your product name / hashtag here",
  undefined: "Enter your product name / hashtag here",
};

export const productFieldDescription = {
  Product: "E.g. Apple Iphone 14 Pro",
  Hashtag: "E.g. #smartphone",
  null: "E.g. Apple Iphone 14 Pro / #smartphone",
  undefined: "E.g. Apple Iphone 14 Pro / #smartphone",
};

export const SpeakerColorScheme = {
  0: ["#FFFFBE", "#E0E08B"],
  1: ["#BECEFF", "#97ADF0"],
  2: ["#FFBEBE ", "#BC6262"],
  3: ["#DDDD70 ", "#B3B385"],
  4: ["#BEDDFF", "#678FBC"],
  5: ["#83B0E3 ", "#556FC1"],
  6: ["#CAC5FF", "#968EE8"],
  7: ["#FFBEDF ", "#BD91A7"],
  8: ["#E88181", "#D95E5E"],
  9: ["#FACD60", "#C7A044"],
  10: ["#FB7756", "#AF472D"],
  11: ["#1AC0C6", "#157376"],
  12: ["#849FFF", "#5F59F7"],
  13: ["#44C2FD", "#3895C1"],
  14: ["#51BDA1", "#2F6859"],
  15: ["#FFD9D4", "#BE7A71"],
  16: ["#8B55E5", "#6843A6"],
  17: ["#F6D912", "#F6D912"],
};

//Previous Projection
export const convertTolongTail = {
  today: "yesterday",
  "1d": "day",
  "1w": "week",
  "1m": "1 month",
  "3m": "3 months",
  "6m": "6 months",
  ytd: "YTD",
  "1y": "year",
};

// v3-dashboard
export const dateRangeDurations = [
  "today",
  "1d",
  "1w",
  "1m",
  "3m",
  "6m",
  "ytd",
  "1y",
  "all_dates",
  "custom",
];

export const mimeTypes = {
  ogm: "video/ogg",
  ogv: "video/ogg",
  ogg: "video/ogg",
  mp4: "video/mp4",
  webm: "video/webm",
};

export const allPrompts = [
  {
    label: "What are the top 10 topics discussed?",
    prompt: "What are the top 10 topics discussed?",
    id: 1,
  },
  {
    label: "What is the overall sentiment expressed?",
    prompt: "What is the overall sentiment expressed?",
    id: 2,
  },
  {
    label: "What demographics are not represented?",
    prompt: "What demographics are not represented?",
    id: 3,
  },
];
